import React, { useEffect, useState } from 'react';
import { Row, Col, Card, CardBody, Modal } from 'reactstrap';
import { get, post, put, del } from 'helpers/api_helper';
import Datatables from 'pages/utils/table/datatable';
import { ManageMedicineColumns } from './tableColumns';
import { MEDICINE_URL } from 'helpers/url_helper';
import { showSuccessAlert, showConfirmAlert } from "pages/utils/alertMessages";
import { AvForm, AvField } from 'availity-reactstrap-validation';

const ManageMedicine = () => {
    const [isForm, setIsForm] = useState(false);
    const [loading, setLoading] = useState(false);
    const [formData, setFormData] = useState({});
    const [rows, setRows] = useState([]);
    const [editMode, setEditMode] = useState(false);
    const [editingId, setEditingId] = useState(null);
    const [pagination, setPagination] = useState({ page: 1, limit: 10, Search: '' });

    const fetchData = async () => {
        setLoading(true);
        const { success, body } = await get(`${MEDICINE_URL}?page=${pagination.page}&limit=${pagination.limit}&search=${pagination.Search}`);
        if (success) {
            setRows(body);
            setLoading(false);
        }
    }

    useEffect(fetchData, [pagination]);

    const handleToggle = () => {
        setIsForm(!isForm);
        setEditMode(false);
        setEditingId(null);
        setFormData({});
        setLoading(false);
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value,
        }));
    };

    const handleSubmit = async () => {
        // console.log('Submitting formData:', formData);
        const url = editMode ? `${MEDICINE_URL}/${editingId}` : MEDICINE_URL;
        const method = editMode ? put : post;

        const { success, body } = await method(url, formData);

        if (success) {
            showSuccessAlert(editMode ? 'Medicine updated successfully!' : 'Medicine created successfully!');
            setIsForm(false);
            setFormData({});
            setEditMode(false);
            setEditingId(null);
            fetchData();
        }
    };

    const handleInvalidSubmit = () => {
        alert("Please enter the input field.");
        // setIsForm(false);
    };

    const handleEdit = (row) => {
        setFormData(row);
        setEditingId(row.id);
        setEditMode(true);
        setIsForm(true);
        setLoading(false);
    };

    const handleDelete = async (id, sts) => {
        const action = sts === 1 ? 'De-activate' : 'Activate';

        const { isConfirmed } = await showConfirmAlert(`${action} Medicine`, `Do you really want to ${action} this Medicine?`,
            `Yes, ${action} it!`, `${action}d!`, `Medicine has been ${action}d successfully.`);

        if (isConfirmed) {
            const { success } = await del(`${MEDICINE_URL}/${id}?sts=${sts}`);
            if (success) {
                fetchData();
            }
        }
    };

    return (
        <React.Fragment>
            <Card>
                <CardBody>
                    <Datatables
                        isSearch={true}
                        columns={ManageMedicineColumns({ "edit": handleEdit, "delete": handleDelete }, pagination)}
                        showTableOnly={true}
                        rowsLength={rows?.totalItems || 0}
                        rows={rows.items || []}
                        keyField={'id'}
                        handleAddButton={handleToggle}
                        title="All Medicines"
                        isAdd={true}
                        isTableHead={true}
                        loading={loading}
                        ssr={setPagination}
                    />
                </CardBody>
            </Card>

            <Modal isOpen={isForm} toggle={handleToggle} size="xl" centered>
                <AvForm onValidSubmit={handleSubmit} onInvalidSubmit={handleInvalidSubmit} model={formData}>
                    <div className="modal-header">
                        <h5 className="modal-title font-weight-bold">
                            {editMode ? 'Update' : 'Create'} Medicine
                        </h5>
                        <button type="button" className="btn-close" onClick={handleToggle} aria-label="Close" />
                    </div>
                    <div className="modal-body p-4">
                        <Row className="g-3">
                            <Col md={4}>
                                <div className="mb-2">
                                    <AvField name="name" label="Medicine Name *" type="text" placeholder="e.g. Amoxicillin 500mg" value={formData.name || ''} onChange={handleChange} required errorMessage="Please Enter Medicine Name" />
                                </div>
                            </Col>
                            <Col md={4}>
                                <div className="mb-2">
                                    <AvField name="molucule" label="Molecule / Generic Composition" type="text" placeholder="e.g. Amoxicillin Trihydrate" value={formData.molucule || ''} onChange={handleChange} />
                                </div>
                            </Col>
                            <Col md={4}>
                                <div className="mb-2">
                                    <AvField name="frequent" label="Frequency" type="text" placeholder="e.g. 1-0-1 (Twice Daily)" value={formData.frequent || ''} onChange={handleChange} />
                                </div>
                            </Col>
                            <Col md={4}>
                                <div className="mb-2">
                                    <AvField name="duration" label="Duration" type="text" placeholder="e.g. 5 Days" value={formData.duration || ''} onChange={handleChange} />
                                </div>
                            </Col>
                            <Col md={4}>
                                <div className="mb-2">
                                    <AvField name="dose" label="Dosage Instructions" type="text" placeholder="e.g. 1 Tablet after food" value={formData.dose || ''} onChange={handleChange} />
                                </div>
                            </Col>
                            <Col md={4}>
                                <div className="form-check form-switch form-switch-md mt-4 d-flex align-items-center gap-2">
                                    <input
                                        type="checkbox"
                                        className="form-check-input"
                                        id="customSwitchsizemd"
                                        name="is_fevrate"
                                        checked={Boolean(formData.is_fevrate)}
                                        onChange={(e) => setFormData(prev => ({ ...prev, is_fevrate: e.target.checked }))}
                                    />
                                    <label className="form-check-label font-weight-semibold mb-0" htmlFor="customSwitchsizemd">
                                        Mark as Favorite Medicine
                                    </label>
                                </div>
                            </Col>
                        </Row>
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-danger" onClick={handleToggle}>
                            Cancel
                        </button>
                        <button type="submit" className="btn btn-primary" disabled={loading}>
                            {loading ? 'Processing...' : (editMode ? 'Update Medicine' : 'Submit Medicine')}
                        </button>
                    </div>
                </AvForm>
            </Modal>
        </React.Fragment>
    );
};

export default ManageMedicine;
